const password = {
    unsupported_encryption_method: '{{name}} şifreleme metodu desteklenmiyor.',
    pepper_not_found: 'Şifre pepperı bulunamadı. Lütfen core envs.i kontrol edin.',
    rejected: 'Şifre reddedildi. Lütfen şifrenizin gereksinimleri karşıladığından emin olun.',
};
export default Object.freeze(password);
